import { isBriefingRelevantById } from "../../briefing-flow/briefing-flow.builder";
import { opsMissionTypeEnum } from "../../plugins/opsctrl-foc/dataStruct";
import { getParametersArrayBulk } from "../../plugins/opsctrl-foc/functions";
import { openFlights } from "./med-crew-view";

/** The ids of the open flights the flow briefing no longer shows: 20 minutes
 *  after the planned arrival, with no flight plan open. The wallboard views use
 *  the card's own rule, so a flight is never over on one and active on the other. */
export async function flightsOver(
  rows: { flightId?: unknown; deleted?: unknown; actArrTime?: unknown }[],
  now: number = Date.now()
): Promise<Set<string>> {
  const ids = openFlights(rows).map((r) => String(r.flightId));
  const params = await getParametersArrayBulk(ids, "flightlist", opsMissionTypeEnum.all);
  return new Set(ids.filter((id) => !isBriefingRelevantById(id, params.get(id) ?? [], now)));
}
